import { type APIAuthType } from "@/core/data_sources/models/APIAuth";
import { post } from "@/core/utils/request";

export function signIn(data: { password: string; email: string }) {
  return post<{ password: string; email: string }, APIAuthType>(
    "/super-admin/auth/login",
    data,
  );
}
export function signOut() {
  return post<Record<string, unknown>, unknown>("/super-admin/auth/logout", {});
}
